import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";

function getScore(weight: number, maxWeight: number) {
  return ((weight + maxWeight) / (maxWeight * 2)) * 100;
}

function WeightTag({ weight, maxWeight }: Props) {
  const score = getScore(weight, maxWeight) / 100;

  return (
    <div
      className={classNames(styles.weightTag, {
        [styles.red]: score < 0.5,
        [styles.orange]: score >= 0.5 && score < 0.65,
        [styles.mediumGreen]: score >= 0.65 && score < 0.8,
        [styles.green]: score >= 0.8,
      })}
    >
      {weight}
    </div>
  );
}

export { WeightTag };
